import { ApolloLink, Observable } from '@apollo/client';

import resolvers from '../transmissions/mockResolvers';

export { resetCarfTransmissionMockStore } from '../transmissions/mockStore';

// Routes CARF mock operations to in-memory resolvers and forwards everything
// else. The demo's ring-fence is the UI layer (the /submissions route gate +
// the feature-flag gate in CarfTransmissionsPageContainer): a non-demo account
// never reaches a surface that fires a `Carf*` op, so this link only ever
// intercepts ops a demo-enabled surface deliberately sent. Gating the link
// itself on the flag would instead break legitimate callers (e.g. the
// admin-views-client records sub-route, which runs under client config).
const carfTransmissionMockLink = new ApolloLink((operation, forward) => {
  const resolver = resolvers[operation.operationName];
  if (!resolver) return forward(operation);

  return new Observable((observer) => {
    Promise.resolve()
      .then(() => resolver(operation.variables || {}))
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((err) => observer.error(err));
  });
});

export default carfTransmissionMockLink;
